// Curated Money Tips shown in the 💡 popover on the Currency page.
// Session-only rotation — see MoneyTipPopover.jsx.
//
// v1: no LLM calls. Local, deterministic, App-Review-safe copy.
// If you edit this list, keep every entry:
//   * general travel-money advice (no country-specific claims that
//     could go stale)
//   * no promises of savings / rates / guarantees
//   * ≤ 140 chars where possible so it fits comfortably on iPhone SE
export const MONEY_TIPS = [
  "Airport exchange booths often have less favorable rates than bank ATMs.",
  "Some countries prefer cash for small purchases even when cards are common.",
  "Dynamic currency conversion may cost more. Paying in the local currency is often cheaper.",
  "Exchange rates can change throughout the day.",
  "Some countries use commas instead of periods for decimal amounts.",
  "A merchant's card terminal rate may differ from the live market rate.",
  "Keep small bills handy for taxis, markets, and tipping.",
  "Check whether your card charges foreign transaction fees before traveling.",
  "ATMs at major banks usually offer better rates than standalone kiosks.",
  "Notify your bank before international travel to avoid card freezes.",
  "Always carry a backup card from a different network (Visa + Mastercard).",
  "Tipping customs vary widely — research local norms before you tip.",
  "Some countries round prices to the nearest unit; others charge to the cent.",
  "Mobile payment (Apple Pay, Alipay, etc.) is universal in some countries, rare in others.",
  "Keep a photo of your passport on your phone, separate from the physical document.",
];

/**
 * Deterministic non-repeating rotation. Given a session-local
 * `lastIndex`, returns the next tip index (never the same one twice
 * in a row).
 */
export function nextTipIndex(lastIndex, listLength = MONEY_TIPS.length) {
  if (listLength <= 1) return 0;
  let next = Math.floor(Math.random() * listLength);
  if (next === lastIndex) next = (next + 1) % listLength;
  return next;
}
